<template>
    <v-dialog :retain-focus="false" v-model="show" persistent max-width="720px">
        <v-card :loading="saving">
            <v-card-title class="text-h6">{{
                item ? 'Edit item' : 'Add item'
            }}</v-card-title>
            <v-card-text>
                <v-text-field
                    v-model="form.lineItemName"
                    label="Name"
                    hide-details="auto"
                    class="mb-6"
                />
                <v-row>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.quantity"
                            label="Opening Quantity"
                            type="number"
                            step="any"
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.width"
                            label="Opening Width"
                            type="number"
                            step="any"
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.height"
                            label="Opening Height"
                            type="number"
                            step="any"
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.horizontalModules"
                            label="Horizontal Modules"
                            type="number"
                            step="any"
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.verticalModules"
                            label="Vertical Modules"
                            type="number"
                            step="any"
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.louverWeight"
                            label="Louver Weight"
                            type="number"
                            step="any"
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" class="py-4">
                        <v-text-field
                            v-model.number="form.netEachPrice"
                            label="Net Each Price"
                            type="number"
                            step="any"
                            :prefix="currency || 'USD'"
                            hide-details="auto"
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text :disabled="saving" @click="close" rounded
                    >Cancel</v-btn
                >
                <v-btn
                    color="primary"
                    :loading="saving"
                    @click="commit"
                    rounded
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { formFromCalculatorItem } from '@/utils/calculatorItemsExcel'

export default {
    name: 'CalculatorItemEditDialog',
    props: {
        value: { type: Boolean, default: false },
        item: { type: Object, default: null },
        saving: { type: Boolean, default: false },
        currency: { type: String, default: 'USD' },
    },
    data() {
        return {
            form: formFromCalculatorItem({}),
        }
    },
    computed: {
        show: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            },
        },
    },
    watch: {
        value(open) {
            if (open) {
                this.form = formFromCalculatorItem(this.item || {})
            }
        },
        item(item) {
            if (this.value) {
                this.form = formFromCalculatorItem(item || {})
            }
        },
    },
    methods: {
        close() {
            this.$emit('input', false)
        },
        commit() {
            this.$emit('save', { ...this.form })
        },
    },
}
</script>
